import styled, { css } from 'styled-components';

import arrow from '../../../assets/img/arrow-grey.svg';
import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';

const getBodyPosition = (value) => {
    switch (value) {
        case 'right':
            return css`
                right: 0;
            `;
        case 'center':
            return css`
                left: 50%;
                transform: translate(-50%, 0);
            `;
        default:
            return '';
    }
};

export const CalendarBody = styled.div`
    width: 352px;
    max-width: 352px;
    height: 332px;
    padding: 8px;
    background: ${COLORS.BgMain};
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, .10);
    border-radius: 16px;
    align-items: baseline;
    flex-direction: column;
    position: absolute;
    z-index: +1;
    display: ${props => props.showCalendar ? 'flex' : 'none'};
    top: 60px;
    ${p => getBodyPosition(p.$position)};
    @media (max-width: 350px) {
        width: 290px;
    }
`;

export const CalendarHeader = styled.div`
    display: flex;
    width: 100%;
    height: 48px;
    justify-content: space-between;
    align-items: center;
`;
export const CalendarDayLine = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-around;
    margin-bottom: 2px;
`;

export const CalendarArrow = styled.div`
    display: flex;
    width: 35px;
    height: 48px;
    cursor: pointer;
    &::before {
    background: url(${arrow}) center center no-repeat;
    position: absolute;
    content: ' ';
    width: 12px;
    height: 8px;
    transform: rotate(90deg);
    margin: 18px 0 0 25px;
  }
`;

export const CalendarMonth = styled.div`
    display: flex;
    ${FONTS.S};
    text-align: center;
    color: ${COLORS.TextPrimary};
`;

export const CalendarDayTitle = styled.div`
    display: flex;
    ${FONTS.S};
    text-align: center;
    color: ${COLORS.TextPrimary};
    height: 36px;
    width: 36px;
    justify-content: center;
    align-items: center;
`;

export const CalendarNumber = styled.div`
    display: flex;
    ${FONTS.S};
    text-align: center;
    color: ${props => props.isDisabled ? COLORS.TextDisabled : COLORS.TextPrimary};
    background: ${props => props.isSelected ? `${COLORS.ButtonSecondary} !important` : COLORS.BgMain};
    border: ${props => props.isNow ? '1px' : '0'} solid ${COLORS.BgSecondary};
    border-radius: 50%;
    height: 36px;
    width: 36px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
         background: ${COLORS.BgSurface};
    }
`;
